import { Grid } from "@mui/material";

const UnderlinedText = ({ text }: { text: string }) => {
  if (text) {
    return (
      <Grid borderBottom={1} item>
        {text}
      </Grid>
    );
  } else {
    return (
      <Grid borderBottom={1} item mt={4}>
        {" "}
      </Grid>
    );
  }
};

export default UnderlinedText;
